import conversationService from "../../services/conversationService";

const state = {
  conversations: []
};

const getters = {
  conversations: state => {
    return state.conversations;
  }
};

const actions = {
  fetchConversationsByAdmin({ commit }) {
    conversationService.fetchConversationsByAdmin().then(conversations => {
      commit("SET_CONVERSATIONS", conversations.data);
    });
  },
  fetchConversations({ commit }) {
    conversationService.fetchConversations().then(conversations => {
      commit("SET_CONVERSATIONS", conversations.data);
    });
  },
  fetchConversationsWithObjects({ commit }) {
    conversationService.fetchConversationsWithObjects().then(conversations => {
      commit("SET_CONVERSATIONS", conversations.data);
    });
  },
  async addConversation({ commit }, payload) {
    let response = await conversationService.postConversation(payload);
    commit("ADD_CONVERSATION", response);
    return response;
  },
  deleteConversation({ commit }, pk) {
    conversationService.deleteConversation(pk);
    commit("DELETE_CONVERSATION", pk);
  }
};

const mutations = {
  SET_CONVERSATIONS(state, conversationList) {
    state.conversations = conversationList;
  },
  ADD_CONVERSATION(state, conversation) {
    state.conversations.push(conversation);
  },
  DELETE_CONVERSATION(state, pk) {
    state.conversations = state.conversations.filter(obj => obj.pk !== pk);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
